import { render, staticRenderFns } from "./VrDefault.vue?vue&type=template&id=1c858280&"
import script from "./VrDefault.vue?vue&type=script&lang=js&"
export * from "./VrDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev ii\\my work\\seo-team-flow\\vue templates\\Vuetify Soft UI Dashboard PRO\\seo-team-flow-ii\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c858280')) {
      api.createRecord('1c858280', component.options)
    } else {
      api.reload('1c858280', component.options)
    }
    module.hot.accept("./VrDefault.vue?vue&type=template&id=1c858280&", function () {
      api.rerender('1c858280', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Dashboard/VrDefault.vue"
export default component.exports